import axios from 'axios';
import { isSafeColour } from '../utils/safeColour';
import { uploadMediaFile } from './mediaDataService';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Upload a logo image file and return its hosted URL (reuses the shared media uploader).
export const uploadBrandLogo = async (file) => {
  const uploadResult = await uploadMediaFile(file);
  if (typeof uploadResult === 'string') return uploadResult;
  if (uploadResult && uploadResult.url) return uploadResult.url;
  if (uploadResult && uploadResult.result) return uploadResult.result;
  throw new Error('Failed to get logo URL from upload response');
};

// Save an individual (self-signup) user's personal branding (logo + theme colour).
// Pass only the fields you want to change. Returns the saved personalBrand.
export const updatePersonalBrand = async ({ logo, themeColors } = {}) => {
  const token = localStorage.getItem('token');
  const body = {};
  if (logo !== undefined) body.logo = logo;
  if (themeColors !== undefined) body.themeColors = themeColors;

  const response = await axios.put(`${API_BASE_URL}/user/personal-brand`, body, {
    headers: { Authorization: `${token}` },
  });
  return response.data?.result || response.data;
};

export const getTheme = async () => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.get(`${API_BASE_URL}/theme`, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    
    // Check if theme data exists in the response
    if (response.data.result?.status && response.data.result?.resource) {
      const resource = response.data.result.resource;
      
      // Set the CSS variable for the primary color
      if (isSafeColour(resource.themeColors?.primary)) {
        document.documentElement.style.setProperty(
          '--primary-color', 
          resource.themeColors.primary
        );
      }
      
      // Return the resource object directly for easier access in components
      return resource;
    } else {
      return null;
    }
  } catch (error) {
    // Just return null on error - will use the default color
    return null;
  }
};